import type { ButtonHTMLAttributes } from "react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "sm" | "md";
};

// Styled by `.a8-button` in styles.css; variant drives the color treatment and
// size the density (sm for in-row actions, md for page-level CTAs).
export function Button({
  variant = "primary",
  size = "md",
  className,
  ...props
}: ButtonProps) {
  const classes = className ? `a8-button ${className}` : "a8-button";
  return <button className={classes} data-variant={variant} data-size={size} {...props} />;
}
